function sendPageView(artId, source) {
  if (!artId || !navigator.sendBeacon) return;
  const keepReading = source === 'keep_reading';
  const payload = JSON.stringify({
    id: artId,
    ref: keepReading ? '' : document.referrer || '',
    q: keepReading ? '' : location.search || '',
    src: keepReading ? 'keep_reading' : undefined
  });
  navigator.sendBeacon('/web/ping', new Blob([payload], {type: 'application/json'}));
}

function initPageViewBeacon(artId) {
  sendPageView(artId, 'page');
}

function initKeepReading(sentinel) {
  if (!('IntersectionObserver' in window)) return;

  let loading = false;
  const originalUrl = window.location.pathname;
  const originalTitle = document.title;

  const readDwellMs = 2000;
  const dwellTimers = new Map();
  const inBand = new Set();

  function stopDwell(el) {
    clearTimeout(dwellTimers.get(el));
    dwellTimers.delete(el);
  }

  function startDwell(el) {
    if (!el.dataset.artId || el.dataset.viewed || dwellTimers.has(el)) return;
    dwellTimers.set(el, window.setTimeout(function () {
      dwellTimers.delete(el);
      if (document.visibilityState !== 'visible' || !inBand.has(el)) return;
      el.dataset.viewed = '1';
      sendPageView(el.dataset.artId, 'keep_reading');
    }, readDwellMs));
  }

  document.addEventListener('visibilitychange', function () {
    inBand.forEach(function (el) {
      if (document.visibilityState === 'visible') {
        startDwell(el);
      } else {
        stopDwell(el);
      }
    });
  });

  const midline = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      const el = e.target;
      if (!e.isIntersecting) {
        inBand.delete(el);
        stopDwell(el);
        return;
      }
      inBand.add(el);
      startDwell(el);
      if (el.dataset.slug) {
        window.history.replaceState(null, '', '/' + el.dataset.slug);
        if (el.dataset.title) {
          document.title = el.dataset.title;
        }
      } else {
        window.history.replaceState(null, '', originalUrl);
        document.title = originalTitle;
      }
    });
  }, {rootMargin: '-45% 0px -45% 0px', threshold: 0});

  const mainArticle = document.querySelector('.art-layout');
  if (mainArticle) {
    midline.observe(mainArticle);
  }

  let armed = true;
  let lastLoadScrollY = 0;
  const rearmScrollDistance = 150;

  function reObserve() {
    observer.unobserve(sentinel);
    observer.observe(sentinel);
  }

  function onScroll() {
    if (!armed && Math.abs(window.scrollY - lastLoadScrollY) > rearmScrollDistance) {
      armed = true;
      reObserve();
    }
  }

  window.addEventListener('scroll', onScroll, {passive: true});

  function teardown() {
    observer.disconnect();
    window.removeEventListener('scroll', onScroll);
    sentinel.remove();
  }

  const observer = new IntersectionObserver(function (entries) {
    const entry = entries[0];
    if (!entry.isIntersecting || loading || !armed) return;

    const nextUrl = sentinel.dataset.next;
    if (!nextUrl) {
      teardown();
      return;
    }

    loading = true;
    sentinel.classList.add('is-loading');

    fetch(nextUrl, {headers: {'X-Requested-With': 'XMLHttpRequest'}})
      .then(function (res) {
        if (!res.ok) throw new Error('fetch failed');
        return res.text();
      })
      .then(function (html) {
        const feed = document.getElementById('keep-reading-feed');
        if (!feed) return;

        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const newEntry = tmp.querySelector('.keep-reading-entry');

        while (tmp.firstChild) {
          feed.appendChild(tmp.firstChild);
        }

        if (newEntry) {
          midline.observe(newEntry);
          initCodeCopy(newEntry);
          initTwitterEmbeds(newEntry);
          initInstagramEmbeds(newEntry);
          initThreadsEmbeds(newEntry);
          initGalleryLightbox(newEntry);
          initImageZoom(newEntry);
        }

        sentinel.classList.remove('is-loading');

        const next = newEntry ? newEntry.dataset.next : '';
        if (next) {
          sentinel.dataset.next = next;
          armed = false;
          lastLoadScrollY = window.scrollY;
        } else {
          teardown();
        }

        loading = false;
      })
      .catch(function () {
        sentinel.classList.remove('is-loading');
        loading = false;
      });
  }, {rootMargin: '0px 0px 100px 0px', threshold: 0});

  observer.observe(sentinel);
}

function initScrollToTop(btn) {
  function update() {
    btn.classList.toggle('visible', window.scrollY > 400);
  }

  window.addEventListener('scroll', update, {passive: true});
  update();
}

function initTickerClose(bar, btn) {
  btn.addEventListener('click', function () {
    bar.style.display = 'none';
    localStorage.setItem('ticker-id', bar.dataset.tickerId);
  });
}

function trackShareEvent(method) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag('event', 'share', {
      method: method,
      content_type: 'article',
      item_id: window.location.pathname
    });
  } catch (_) {
  }
}

function initArticleShare(containers) {
  const targets = {
    x: function (url, text) {
      return 'https://twitter.com/intent/tweet?url=' + url + '&text=' + text;
    },
    facebook: function (url) {
      return 'https://www.facebook.com/sharer/sharer.php?u=' + url;
    },
    linkedin: function (url) {
      return 'https://www.linkedin.com/sharing/share-offsite/?url=' + url;
    },
    whatsapp: function () {
      return 'https://wa.me/?text=' + encodeURIComponent(document.title + ' ' + window.location.href);
    },
    threads: function (url, text) {
      return 'https://www.threads.net/intent/post?text=' + text + '%20' + url;
    },
    bluesky: function (url, text) {
      return 'https://bsky.app/intent/compose?text=' + text + '%20' + url;
    }
  };

  containers.forEach(function (container) {
    if (!container) return;

    container.querySelectorAll('[data-share]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const type = btn.dataset.share;

        trackShareEvent(type);

        if (type === 'copy') {
          navigator.clipboard.writeText(window.location.href).then(function () {
            btn.classList.add('copied');
            setTimeout(function () {
              btn.classList.remove('copied');
            }, 2000);
          });
          return;
        }

        if (type === 'email') {
          window.location.href = 'mailto:?subject=' + encodeURIComponent(document.title) +
            '&body=' + encodeURIComponent(window.location.href);
          return;
        }

        const url = encodeURIComponent(window.location.href);
        const text = encodeURIComponent(document.title);
        if (targets[type]) {
          window.open(targets[type](url, text), '_blank', 'width=600,height=400,noopener');
        }
      });
    });
  });
}

function initTwitterEmbeds(root) {
  const scope = root || document;
  if (!scope.querySelectorAll('.twitter-tweet').length) return;

  if (window.twttr && window.twttr.widgets && typeof window.twttr.widgets.load === 'function') {
    window.twttr.widgets.load(root || undefined);
    return;
  }

  if (document.getElementById('twitter-wjs')) return;

  const script = document.createElement('script');
  script.id = 'twitter-wjs';
  script.src = 'https://platform.twitter.com/widgets.js';
  script.async = true;
  script.charset = 'utf-8';
  document.body.appendChild(script);
}

function bindInstagramResize() {
  if (window.__igResizeBound) return;
  window.__igResizeBound = true;

  window.addEventListener('message', function (e) {
    if (!e.origin || e.origin.indexOf('instagram.com') === -1) return;

    let data;
    try {
      data = typeof e.data === 'string' ? JSON.parse(e.data) : e.data;
    } catch (_) {
      return;
    }

    if (!data || data.type !== 'MEASURE' || !data.details || !data.details.height) return;

    const frames = document.querySelectorAll('iframe.instagram-media');
    for (let i = 0; i < frames.length; i++) {
      if (frames[i].contentWindow === e.source) {
        frames[i].style.height = data.details.height + 'px';
        const fig = frames[i].closest('.editor-embed--instagram');
        if (fig) fig.classList.add('ig-ready');
      }
    }
  });
}

function revealInstagramFallback(scope) {
  setTimeout(function () {
    scope.querySelectorAll('.editor-embed--instagram').forEach(function (fig) {
      fig.classList.add('ig-ready');
    });
  }, 6000);
}

function initInstagramEmbeds(root) {
  const scope = root || document;
  if (!scope.querySelectorAll('.instagram-media').length) return;

  bindInstagramResize();
  revealInstagramFallback(scope);

  if (window.instgrm && window.instgrm.Embeds && typeof window.instgrm.Embeds.process === 'function') {
    window.instgrm.Embeds.process();
    return;
  }

  if (document.getElementById('instagram-embed-js')) return;

  const script = document.createElement('script');
  script.id = 'instagram-embed-js';
  script.src = 'https://www.instagram.com/embed.js';
  script.async = true;
  document.body.appendChild(script);
}

function initThreadsEmbeds(root) {
  const scope = root || document;
  const figures = scope.querySelectorAll('.editor-embed--threads');
  if (!figures.length) return;

  figures.forEach(function (fig) {
    if (fig.dataset.thWatch) return;
    fig.dataset.thWatch = '1';

    const reveal = function () { fig.classList.add('th-ready'); };
    if (fig.querySelector('iframe')) {
      reveal();
      return;
    }

    let timer = null;
    const obs = new MutationObserver(function () {
      if (fig.querySelector('iframe')) {
        if (timer) clearTimeout(timer);
        reveal();
        obs.disconnect();
      }
    });
    obs.observe(fig, {childList: true, subtree: true});
    timer = setTimeout(function () {
      reveal();
      obs.disconnect();
    }, 6000);
  });

  const existing = document.getElementById('threads-embed-js');
  if (existing) {
    existing.remove();
  }
  const script = document.createElement('script');
  script.id = 'threads-embed-js';
  script.src = 'https://www.threads.net/embed.js';
  script.async = true;
  document.body.appendChild(script);
}

function initCodeCopy(root) {
  const copyIcon =
    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
    '<rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>' +
    '<path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>' +
    '</svg>';
  const checkIcon =
    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
    '<polyline points="20 6 9 17 4 12"></polyline>' +
    '</svg>';

  const listOf = (root || document).querySelectorAll('.code-copy-btn:not([data-copy-ready])');
  listOf.forEach(function (btn) {
    btn.dataset.copyReady = '1';
    btn.innerHTML = copyIcon;
    btn.addEventListener('click', function () {
      const pre = btn.parentElement && btn.parentElement.querySelector('pre code');
      if (!pre || !navigator.clipboard) {
        return;
      }

      navigator.clipboard.writeText(pre.textContent || '').then(function () {
        btn.classList.add('copied');
        btn.innerHTML = checkIcon;

        setTimeout(function () {
          btn.classList.remove('copied');
          btn.innerHTML = copyIcon;
        }, 2000);
      }).catch(function () {
      });
    });
  });
}

function initTocScrollSpy() {
  const toc = document.querySelector('.toc-block');
  if (!toc) { return; }

  const details = toc.querySelector('.toc-details');
  const links = toc.querySelectorAll('.toc-list li');
  const entries = Array.from(links).map(li => {
    const a = li.querySelector('a');
    const id = a ? a.getAttribute('href').substring(1) : '';
    const heading = id ? document.getElementById(id) : null;
    return heading ? { li, heading } : null;
  }).filter(Boolean);

  if (entries.length === 0) { return; }

  toc.addEventListener('click', e => {
    const link = e.target.closest('.toc-list a');
    if (link && details) {
      details.removeAttribute('open');
    }
  });

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        links.forEach(li => li.classList.remove('toc-active'));
        const match = entries.find(item => item.heading === entry.target);
        if (match) {
          match.li.classList.add('toc-active');
        }
      }
    });
  }, { rootMargin: '-80px 0px -60% 0px' });

  entries.forEach(item => observer.observe(item.heading));
}

// Shared lightbox — one overlay reused by galleries and single body images.
// Created lazily on first use. open(items, idx) drives an arbitrary image set.
let _lightbox = null;

const ZOOM_ICON = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 3H5a2 2 0 0 0-2 2v3M16 3h3a2 2 0 0 1 2 2v3M21 16v3a2 2 0 0 1-2 2h-3M3 16v3a2 2 0 0 0 2 2h3"/></svg>';

function getLightbox() {
  if (_lightbox) return _lightbox;

  const lb = document.createElement('div');
  lb.className = 'gallery-lb';
  lb.innerHTML =
    '<button class="gallery-lb__prev" aria-label="Previous">&#8249;</button>' +
    '<div class="gallery-lb__stage">' +
    '<img class="gallery-lb__img" src="" alt=""/>' +
    '<p class="gallery-lb__caption"></p>' +
    '</div>' +
    '<button class="gallery-lb__next" aria-label="Next">&#8250;</button>' +
    '<button class="gallery-lb__close" aria-label="Close">&times;</button>';
  document.body.appendChild(lb);

  const lbImg = lb.querySelector('.gallery-lb__img');
  const lbCaption = lb.querySelector('.gallery-lb__caption');
  const lbPrev = lb.querySelector('.gallery-lb__prev');
  const lbNext = lb.querySelector('.gallery-lb__next');
  const lbClose = lb.querySelector('.gallery-lb__close');

  let items = [];
  let current = 0;
  let isOpen = false;

  // Capture-phase blocker: while lightbox is open, swallow any click
  // that didn't originate inside the lightbox element itself.
  function captureBlock(e) {
    if (!lb.contains(e.target)) {
      e.stopPropagation();
      e.preventDefault();
    }
  }

  function show() {
    const item = items[current];
    if (!item) return;
    lbImg.src = item.src;
    lbImg.alt = item.alt || '';
    lbCaption.textContent = item.caption || '';
    lbPrev.style.display = current <= 0 ? 'none' : '';
    lbNext.style.display = current >= items.length - 1 ? 'none' : '';
  }

  function open(list, idx) {
    if (isOpen || !list || !list.length) return;
    items = list;
    current = idx || 0;
    isOpen = true;
    show();
    lb.classList.add('gallery-lb--open');
    document.body.style.overflow = 'hidden';
    document.addEventListener('click', captureBlock, true);
  }

  function close() {
    isOpen = false;
    lb.classList.remove('gallery-lb--open');
    document.body.style.overflow = '';
    document.removeEventListener('click', captureBlock, true);
    setTimeout(function () { lbImg.src = ''; }, 200);
  }

  // Click anywhere outside the image or the controls closes the viewer.
  lb.addEventListener('click', function (e) {
    if (e.target === lbImg) return;
    if (e.target.closest('.gallery-lb__prev, .gallery-lb__next, .gallery-lb__close')) return;
    close();
  });

  lbClose.addEventListener('click', close);
  lbPrev.addEventListener('click', function (e) {
    e.preventDefault();
    if (current > 0) { current--; show(); }
  });
  lbNext.addEventListener('click', function (e) {
    e.preventDefault();
    if (current < items.length - 1) { current++; show(); }
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'ArrowLeft' && current > 0) { e.preventDefault(); current--; show(); }
    if (e.key === 'ArrowRight' && current < items.length - 1) { e.preventDefault(); current++; show(); }
  });

  _lightbox = {open: open};
  return _lightbox;
}

function initGalleryLightbox(root) {
  const scope = root || document;
  const galleries = scope.querySelectorAll('.editor-gallery');
  if (!galleries.length) return;

  const CHEVRON_LEFT = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>';
  const CHEVRON_RIGHT = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';
  galleries.forEach(function (gallery) {
    const items = [];
    gallery.querySelectorAll('.editor-gallery__item').forEach(function (item) {
      const img = item.querySelector('img');
      if (!img) return;
      const idx = items.length;
      items.push({src: img.dataset.full || img.src, alt: img.alt || '', caption: item.dataset.caption || ''});

      const open = function () { getLightbox().open(items, idx); };
      item.style.cursor = 'pointer';
      item.addEventListener('click', open);

      const wrap = item.querySelector('.editor-gallery__img-wrap') || item;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'editor-gallery__zoom';
      btn.setAttribute('aria-label', 'View full image');
      btn.innerHTML = ZOOM_ICON;
      btn.addEventListener('click', function (e) { e.stopPropagation(); open(); });
      wrap.appendChild(btn);
    });

    if (items.length > 1 && !gallery.dataset.galleryNav) {
      if (gallery.dataset.layout === 'carousel') {
        wireGalleryCarousel(gallery, CHEVRON_LEFT, CHEVRON_RIGHT);
      } else {
        wireGalleryChevrons(gallery, CHEVRON_LEFT, CHEVRON_RIGHT);
      }
    }
  });
}

function wireGalleryCarousel(gallery, chevronLeft, chevronRight) {
  gallery.dataset.galleryNav = '1';

  const realItems = Array.prototype.slice.call(
    gallery.querySelectorAll('.editor-gallery__item')
  );
  const n = realItems.length;
  if (n < 2) return;

  const wrap = document.createElement('div');
  wrap.className = 'editor-gallery-wrap editor-gallery-wrap--carousel';
  if (gallery.dataset.size) {
    wrap.dataset.size = gallery.dataset.size;
  }
  gallery.parentNode.insertBefore(wrap, gallery);

  const viewport = document.createElement('div');
  viewport.className = 'editor-gallery-viewport';
  wrap.appendChild(viewport);
  viewport.appendChild(gallery);

  const headClone = realItems[n - 1].cloneNode(true);
  const tailClone = realItems[0].cloneNode(true);
  [headClone, tailClone].forEach(function (clone) {
    clone.classList.add('editor-gallery__item--clone');
    clone.setAttribute('aria-hidden', 'true');
    clone.style.cursor = 'default';
  });
  gallery.insertBefore(headClone, realItems[0]);
  gallery.appendChild(tailClone);

  // The server renders a small grid-thumbnail `sizes` (~400px). For a carousel
  // the slide is far bigger, so with width:auto the browser would still lay the
  // image out at 400px. Re-declare `sizes` to the stage width per Size preset so
  // the image renders large (CSS max-width/max-height then keep the aspect).
  const CAROUSEL_SIZES = {
    small: '(max-width: 767px) 100vw, 460px',
    medium: '(max-width: 767px) 100vw, 680px',
    large: '(max-width: 767px) 100vw, 900px',
    full: '100vw'
  };
  const sizesValue = CAROUSEL_SIZES[gallery.dataset.size] || CAROUSEL_SIZES.medium;
  gallery.querySelectorAll('img[srcset]').forEach(function (img) {
    img.sizes = sizesValue;
  });

  const prevBtn = document.createElement('button');
  prevBtn.type = 'button';
  prevBtn.className = 'gallery-chevron gallery-chevron--prev';
  prevBtn.setAttribute('aria-label', 'Previous image');
  prevBtn.innerHTML = chevronLeft;

  const nextBtn = document.createElement('button');
  nextBtn.type = 'button';
  nextBtn.className = 'gallery-chevron gallery-chevron--next';
  nextBtn.setAttribute('aria-label', 'Next image');
  nextBtn.innerHTML = chevronRight;

  wrap.appendChild(prevBtn);
  wrap.appendChild(nextBtn);

  const dotsBar = document.createElement('div');
  dotsBar.className = 'gallery-dots';
  const dots = realItems.map(function (item, idx) {
    const dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'gallery-dot';
    dot.setAttribute('aria-label', 'Go to image ' + (idx + 1));
    dot.addEventListener('click', function () { goToReal(idx); });
    dotsBar.appendChild(dot);
    return dot;
  });
  wrap.appendChild(dotsBar);

  // pos 0 is the head clone, 1..n the real slides, n+1 the tail clone.
  let pos = 1;
  let animating = false;
  let settleTimer = null;

  function apply(animate) {
    gallery.style.transition = animate ? '' : 'none';
    gallery.style.transform = 'translateX(' + (-pos * 100) + '%)';
    if (!animate) {
      void gallery.offsetWidth;
      gallery.style.transition = '';
    }
  }

  function realIndex() {
    return ((pos - 1) % n + n) % n;
  }

  function updateDots() {
    const ri = realIndex();
    dots.forEach(function (dot, idx) {
      dot.classList.toggle('gallery-dot--active', idx === ri);
    });
  }

  // Runs once per move, whichever fires first: the transitionend or a fallback
  // timer. The fallback guarantees the carousel never stays stuck if a
  // transitionend is missed (interrupted transition, reduced-motion, etc.).
  function settle() {
    if (settleTimer) {
      clearTimeout(settleTimer);
      settleTimer = null;
    }
    animating = false;
    if (pos === 0) {
      pos = n;
      apply(false);
    } else if (pos === n + 1) {
      pos = 1;
      apply(false);
    }
  }

  function animateTo(next) {
    if (animating || next === pos) return;
    animating = true;
    pos = next;
    apply(true);
    updateDots();
    if (settleTimer) {
      clearTimeout(settleTimer);
    }
    settleTimer = setTimeout(settle, 600);
  }

  function move(delta) {
    animateTo(pos + delta);
  }

  function goToReal(idx) {
    if (idx !== realIndex()) {
      animateTo(idx + 1);
    }
  }

  gallery.addEventListener('transitionend', function (e) {
    if (e.target !== gallery || e.propertyName !== 'transform' || !animating) {
      return;
    }
    settle();
  });

  prevBtn.addEventListener('click', function () { move(-1); });
  nextBtn.addEventListener('click', function () { move(1); });

  // Shrink the stage to the actual image so the edge chevrons hug it instead of
  // floating in empty container space. Re-fits on image load and window resize;
  // on mobile the image fills the viewport, so the stage stays full-width.
  const mobileQuery = window.matchMedia('(max-width: 767px)');
  function fitStageToImage() {
    if (mobileQuery.matches) {
      wrap.style.maxWidth = '';
      return;
    }
    let widest = 0;
    realItems.forEach(function (item) {
      const img = item.querySelector('img');
      if (img) {
        widest = Math.max(widest, img.getBoundingClientRect().width);
      }
    });
    if (widest > 0) {
      wrap.style.maxWidth = Math.ceil(widest) + 'px';
    }
  }
  realItems.forEach(function (item) {
    const img = item.querySelector('img');
    if (img && !img.complete) {
      img.addEventListener('load', fitStageToImage, {once: true});
    }
  });
  mobileQuery.addEventListener('change', fitStageToImage);

  // Passive touch swipe for mobile; no touchmove handler, so vertical page
  // scrolling stays smooth.
  let touchStartX = null;
  viewport.addEventListener('touchstart', function (e) {
    touchStartX = e.touches[0].clientX;
  }, {passive: true});
  viewport.addEventListener('touchend', function (e) {
    if (touchStartX === null) {
      return;
    }
    const dx = e.changedTouches[0].clientX - touchStartX;
    touchStartX = null;
    if (Math.abs(dx) > 40) {
      move(dx < 0 ? 1 : -1);
    }
  }, {passive: true});

  apply(false);
  updateDots();
  fitStageToImage();
}

function wireGalleryChevrons(gallery, chevronLeft, chevronRight) {
  gallery.dataset.galleryNav = '1';

  const wrap = document.createElement('div');
  wrap.className = 'editor-gallery-wrap';
  gallery.parentNode.insertBefore(wrap, gallery);
  wrap.appendChild(gallery);

  const prevBtn = document.createElement('button');
  prevBtn.type = 'button';
  prevBtn.className = 'gallery-chevron gallery-chevron--prev gallery-chevron--hidden';
  prevBtn.setAttribute('aria-label', 'Previous images');
  prevBtn.innerHTML = chevronLeft;

  const nextBtn = document.createElement('button');
  nextBtn.type = 'button';
  nextBtn.className = 'gallery-chevron gallery-chevron--next gallery-chevron--hidden';
  nextBtn.setAttribute('aria-label', 'Next images');
  nextBtn.innerHTML = chevronRight;

  wrap.appendChild(prevBtn);
  wrap.appendChild(nextBtn);

  const edgeTolerance = 5;

  function updateChevrons() {
    const maxScroll = gallery.scrollWidth - gallery.clientWidth;
    const overflowing = maxScroll > edgeTolerance;
    const atStart = gallery.scrollLeft <= edgeTolerance;
    const atEnd = gallery.scrollLeft >= maxScroll - edgeTolerance;

    prevBtn.classList.toggle('gallery-chevron--hidden', !overflowing || atStart);
    nextBtn.classList.toggle('gallery-chevron--hidden', !overflowing || atEnd);
  }

  function page(direction) {
    gallery.scrollBy({left: direction * gallery.clientWidth, behavior: 'smooth'});
  }

  prevBtn.addEventListener('click', function () { page(-1); });
  nextBtn.addEventListener('click', function () { page(1); });

  let ticking = false;
  gallery.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      updateChevrons();
      ticking = false;
    });
  }, {passive: true});

  if ('ResizeObserver' in window) {
    new ResizeObserver(updateChevrons).observe(gallery);
  } else {
    window.addEventListener('resize', updateChevrons, {passive: true});
  }

  gallery.querySelectorAll('img').forEach(function (img) {
    if (!img.complete) {
      img.addEventListener('load', updateChevrons, {once: true});
    }
  });

  updateChevrons();
}

function initImageZoom(root) {
  const scope = root || document;
  const figures = scope.querySelectorAll('.editor-body .editor-image[data-full]');
  if (!figures.length) return;

  figures.forEach(function (fig) {
    const full = fig.getAttribute('data-full');
    if (!full) return;

    const width = fig.getAttribute('data-width');
    if (width) fig.style.setProperty('--img-max', width + '%');

    const img = fig.querySelector('img');
    const cap = fig.querySelector('figcaption');
    const item = {src: full, alt: img ? img.alt : '', caption: cap ? cap.textContent : ''};
    const openZoom = function (e) { e.preventDefault(); getLightbox().open([item], 0); };

    // Anchor the zoom to a frame that hugs the image itself. The figure is
    // fit-content on the image's intrinsic width, but a tall image capped by
    // max-height renders narrower — so a button pinned to the figure would sit
    // in the margin. The frame shrinks to the rendered image, keeping the button
    // on the image's own top-right corner.
    let frame = fig.querySelector('.editor-image__frame');
    if (!frame && img) {
      frame = document.createElement('span');
      frame.className = 'editor-image__frame';
      img.parentNode.insertBefore(frame, img);
      frame.appendChild(img);
    }

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'editor-image__zoom';
    btn.setAttribute('aria-label', 'View full image');
    btn.innerHTML = ZOOM_ICON;
    btn.addEventListener('click', openZoom);
    (frame || fig).appendChild(btn);

    if (img) {
      img.style.cursor = 'pointer';
      img.addEventListener('click', openZoom);
    }
  });
}
